/** Serialize any Matra tree or value without applying domain semantics. */
export function printJSON(value: unknown, options: { pretty?: boolean } = {}): string {
  return JSON.stringify(value, null, options.pretty ? 2 : undefined)
}
